import moment from "moment";

const getPostingDateFormat = (date: string): string => moment(date).format("D MMM, YYYY");

export {
  getPostingDateFormat
};